import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";

export interface ConfirmModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-price-search',
  templateUrl: './price-search.component.html',
  styleUrls: ['./price-search.component.css']
})

export class PriceSearchComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel, OnInit {
  title: string;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  data: any;

  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  fullData: any;

  private el: ElementRef;
  @Input() onReturn: string;

  constructor(dialogService: DialogService) {
    super(dialogService);
    this.fullData = this.data;
  }

  ngOnInit() {
    this.fullData = this.data;
    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.length > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }

  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.find(x => x.LevelId == abc);
    this.confirm(bcd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/price-search/price-search.component.ts